import { GET, POST, PUT, DELETE } from './api'

const table = "share-links"

export const CreateShareLink = async (params) => {
  return await POST(`/${table}/generate`, params, true);
}

export const ReadContent = async (token) => {
  return await GET(`/${table}/resolve/${token}`, false);
}

export const ReadOne = async (id) => {
  return await GET(`/${table}/${id}?populate=*`, true);
}

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
}

export const Delete = async (id) => {
  return await DELETE(`/${table}/${id}`, true);
}
